// extracted by css-extract-rspack-plugin
export default {"Box":"ReferencedEvent-module__Box__a607E"};